// API Configuration
// This file contains the base URL for all API requests

// Development environment
// const API_BASE_URL = 'http://192.168.1.3:8000/nassarFileSystem/';

// Production environment (uncomment when deploying)
const API_BASE_URL = 'https://api.nassar-fbs.com/nassarFileSystem/';

// Export the API base URL
export const apiBaseUrl = API_BASE_URL;


// API timeout configuration (in milliseconds)
export const API_TIMEOUT = 30000;

// Default headers
export const DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
};

const config = {
    apiBaseUrl,
    API_TIMEOUT,
    DEFAULT_HEADERS,
};

export default config;


